export default {
  title: 'Lade die {{app}} App herunter',
  qr_code_desc: 'Scanne diesen QR-Code mit deinem Handy, um die App herunterzuladen',
  cta: 'Lade die App herunter und melde dich an, um {{amount}} Cashback zu erhalten!',
  download_from: 'Oder lade sie herunter von:',
  direct_link: 'Direkter Link:',
};
